import React from 'react';
import ReactDOM from 'react-dom';
import GlobalSearchComp from './search-modal';
import SearchListTableComp from './search-list-table';
import {WbUniqueIdMixin} from '../../utils/common';
import SearchTagComp from './search-tag';

const initGlobalSearchComp = (data) => {
    if (document.getElementById('quick-search')) {
        ReactDOM.render(<GlobalSearchComp key={WbUniqueIdMixin.randomId('global-search-')} {...data} />, document.getElementById('quick-search-render'));
    }
}

const initSearchListTableComp = (data, elementId) => {
    let element = document.getElementById(elementId);
    if (element) {
        ReactDOM.render(<SearchListTableComp {...data} />, element);
    }
}

const initSearchTagComp = (data, elementId) => {
    let element = document.getElementById(elementId);
    if (element) {
        ReactDOM.render(<SearchTagComp {...data} />, element);
    }
}

window.initGlobalSearchComp = initGlobalSearchComp;
window.initSearchListTableComp = initSearchListTableComp;
window.initSearchTagComp = initSearchTagComp;
